import { IndexPage } from './IndexPage';
import { DetailPage } from './DetailPage';

export {
IndexPage,
DetailPage
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Users/index.ts
 **/